import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import appLS from "./constants/local-storage";
import translationEN from './locales/en/translations.json';
import translationNo from './locales/no/translations.json';

const resources = {
  en: {
    translation: translationEN
  },
  no: {
    translation: translationNo
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem(appLS.appLanguage) || 'no',

    keySeparator: '.',

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;